import { CSV_FORMAT, CSV_ROW_FORMAT_PROPS } from './model.model';

export const UNIT_TYPE_PREFIXES = {
  outdoorUnitMasterVrv: '%OUMV_',
  outdoorUnitSlave1Vrv: '%OUS1V_',
  outdoorUnitSlave2Vrv: '%OUS2V_',
  outdoorUnit: '%OU_',
  waterTank: '%WT_',
  boosterHeater: '%BoH_',
  backupHeater: '%BaH_',
  controller: '%RC_',
  fanCoilUnit: '%FU_',
  radiator: '%R_',
  boiler: '%B_',
  other: '%O_',
  indoorUnit: '%IU_',
  indoorUnit2: '%IU2_',
  indoorUnit3: '%IU3_',
  indoorUnit4: '%IU4_',
  indoorUnit5: '%IU5_',
  indoorUnit6: '%IU6_',
  indoorUnit7: '%IU7_',
  indoorUnit8: '%IU8_',
  indoorUnit9: '%IU9_',
  indoorUnit10: '%IU10_',
  indoorUnit11: '%IU11_',
  indoorUnit12: '%IU12_',
  indoorUnit13: '%IU13_',
  indoorUnit14: '%IU14_',
  indoorUnit15: '%IU15_',
  indoorUnit16: '%IU16_',
  indoorUnit17: '%IU17_',
  indoorUnit18: '%IU18_',
  indoorUnit19: '%IU19_',
  indoorUnit20: '%IU20_',
  indoorUnit21: '%IU21_',
  indoorUnit22: '%IU22_',
  indoorUnit23: '%IU23_',
  indoorUnit24: '%IU24_',
  indoorUnit25: '%IU25_',
  indoorUnit26: '%IU26_',
  indoorUnit27: '%IU27_',
  indoorUnit28: '%IU28_',
  indoorUnit29: '%IU29_',
  indoorUnit30: '%IU30_',
  indoorUnit31: '%IU31_',
  indoorUnit32: '%IU32_',
  indoorUnit33: '%IU33_',
  indoorUnit34: '%IU34_',
  indoorUnit35: '%IU35_',
  indoorUnit36: '%IU36_',
  indoorUnit37: '%IU37_',
  indoorUnit38: '%IU38_',
  indoorUnit39: '%IU39_',
  indoorUnit40: '%IU40_',
  indoorUnit41: '%IU41_',
  indoorUnit42: '%IU42_',
  indoorUnit43: '%IU43_',
  indoorUnit44: '%IU44_',
  indoorUnit45: '%IU45_',
  indoorUnit46: '%IU46_',
  indoorUnit47: '%IU47_',
  indoorUnit48: '%IU48_',
  indoorUnit49: '%IU49_',
  indoorUnit50: '%IU50_',
  indoorUnit51: '%IU51_',
  indoorUnit52: '%IU52_',
  indoorUnit53: '%IU53_',
  indoorUnit54: '%IU54_',
  indoorUnit55: '%IU55_',
  indoorUnit56: '%IU56_',
  indoorUnit57: '%IU57_',
  indoorUnit58: '%IU58_',
  indoorUnit59: '%IU59_',
  indoorUnit60: '%IU60_',
  indoorUnit61: '%IU61_',
  indoorUnit62: '%IU62_',
  indoorUnit63: '%IU63_',
  indoorUnit64: '%IU64_',
} as const;

export const ATOM = {
  variable: 'var',
  outdoorUnitMasterVrv: 'oumv',
  outdoorUnitSlave1Vrv: 'ous1v',
  outdoorUnitSlave2Vrv: 'ous2v',
  outdoorUnit: 'ou',
  waterTank: 'wt',
  boosterHeater: 'boh',
  backupHeater: 'bah',
  controller: 'rc',
  fanCoilUnit: 'fu',
  radiator: 'r',
  boiler: 'b',
  other: 'o',
  indoorUnit: 'iu',
  indoorUnit2: 'iu2',
  indoorUnit3: 'iu3',
  indoorUnit4: 'iu4',
  indoorUnit5: 'iu5',
  indoorUnit6: 'iu6',
  indoorUnit7: 'iu7',
  indoorUnit8: 'iu8',
  indoorUnit9: 'iu9',
  indoorUnit10: 'iu10',
  indoorUnit11: 'iu11',
  indoorUnit12: 'iu12',
  indoorUnit13: 'iu13',
  indoorUnit14: 'iu14',
  indoorUnit15: 'iu15',
  indoorUnit16: 'iu16',
  indoorUnit17: 'iu17',
  indoorUnit18: 'iu18',
  indoorUnit19: 'iu19',
  indoorUnit20: 'iu20',
  indoorUnit21: 'iu21',
  indoorUnit22: 'iu22',
  indoorUnit23: 'iu23',
  indoorUnit24: 'iu24',
  indoorUnit25: 'iu25',
  indoorUnit26: 'iu26',
  indoorUnit27: 'iu27',
  indoorUnit28: 'iu28',
  indoorUnit29: 'iu29',
  indoorUnit30: 'iu30',
  indoorUnit31: 'iu31',
  indoorUnit32: 'iu32',
  indoorUnit33: 'iu33',
  indoorUnit34: 'iu34',
  indoorUnit35: 'iu35',
  indoorUnit36: 'iu36',
  indoorUnit37: 'iu37',
  indoorUnit38: 'iu38',
  indoorUnit39: 'iu39',
  indoorUnit40: 'iu40',
  indoorUnit41: 'iu41',
  indoorUnit42: 'iu42',
  indoorUnit43: 'iu43',
  indoorUnit44: 'iu44',
  indoorUnit45: 'iu45',
  indoorUnit46: 'iu46',
  indoorUnit47: 'iu47',
  indoorUnit48: 'iu48',
  indoorUnit49: 'iu49',
  indoorUnit50: 'iu50',
  indoorUnit51: 'iu51',
  indoorUnit52: 'iu52',
  indoorUnit53: 'iu53',
  indoorUnit54: 'iu54',
  indoorUnit55: 'iu55',
  indoorUnit56: 'iu56',
  indoorUnit57: 'iu57',
  indoorUnit58: 'iu58',
  indoorUnit59: 'iu59',
  indoorUnit60: 'iu60',
  indoorUnit61: 'iu61',
  indoorUnit62: 'iu62',
  indoorUnit63: 'iu63',
  indoorUnit64: 'iu64',
  stringLiteral: 'str',
  numberLiteral: 'num',
  boolLiteral: 'bool',
} as const;
export const OPERATOR = {
  equality: 'eop',
  comparison: 'cop',
  logical: 'lop',
  arithmetic: 'aop',
} as const;
export const PAREN = {
  left: 'left-paren',
  right: 'right-paren',
} as const;
const PROPERTY_NAME = {
  type: 't',
  value: 'v',
  left: 'l',
  right: 'r',
} as const;

type AtomType = (typeof ATOM)[keyof typeof ATOM];
type OperatorType = (typeof OPERATOR)[keyof typeof OPERATOR];
type ParenType = (typeof PAREN)[keyof typeof PAREN];
type TokenType = AtomType | OperatorType | ParenType | 'end-of-line';
type Token = {
  [PROPERTY_NAME.type]: TokenType;
  [PROPERTY_NAME.value]: string;
};
type AtomNode = {
  [PROPERTY_NAME.type]: AtomType;
  [PROPERTY_NAME.value]: string;
};
type OperatorNode = {
  [PROPERTY_NAME.type]: OperatorType;
  [PROPERTY_NAME.value]: string;
  [PROPERTY_NAME.left]: AbstractSyntaxTreeNode;
  [PROPERTY_NAME.right]: AbstractSyntaxTreeNode;
};
type AbstractSyntaxTreeNode = AtomNode | OperatorNode;

const MAX_CONDITION_NUM = 40;

const EQUALITY_OPERATOR_REGEX = /^[=!]=/;
const COMPARISON_OPERATOR_REGEX = /^[<>](=)?/;
const STRING_LITERAL_REGEX = /^"[^"]+"/;
const NUMBER_LITERAL_REGEX = /^(?<!\d)-?\d{1,6}(?:[.,]\d{1,3})?(?!\d)/;
const BOOL_LITERAL_REGEX = /^(True|False)/;

const VARIABLE_NUMBER_PATTERN = /([0-9a-fA-F]{12}7[0-9a-fA-F]{3}[89abAB][0-9a-fA-F]{15})/;
const VARIABLE_REGEX = new RegExp(`^\\$${VARIABLE_NUMBER_PATTERN.source}`);

const INSTALLATION_KEY = 'inst';
const MODEL_MASTER_PATTERN = CSV_ROW_FORMAT_PROPS.join('|');
const MODEL_PATTERN = `(${MODEL_MASTER_PATTERN}|${INSTALLATION_KEY})`;

const isOperatorType = (value: string): value is OperatorType => Object.values(OPERATOR).includes(value as OperatorType);
const isParenType = (value: string): value is ParenType => Object.values(PAREN).includes(value as ParenType);

abstract class AbstractError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

class LexicalError extends AbstractError {
  constructor(
    message: string,
    public char: string,
    public pos: number,
  ) {
    super(message);
  }
}

class SemanticError extends AbstractError {
  constructor(
    message: string,
    public node: AbstractSyntaxTreeNode,
  ) {
    super(message);
  }
}

export class ConditionSyntax {
  static convertToAst(input: string, resultTypeMap: Map<string, string>): AbstractSyntaxTreeNode | undefined {
    try {
      const tokens = ConditionSyntax.tokenize(input);
      const ast = ConditionSyntax.parse(tokens);
      ConditionSyntax.analyze(ast, resultTypeMap);
      return ast;
    } catch {
      return undefined;
    }
  }

  static tokenize(input: string): Token[] {
    let pos = 0;
    const tokens: Token[] = [];
    const extract = (regex: RegExp): string | null => {
      const text = regex.exec(input.slice(pos));
      return text ? text[0] : null;
    };
    const extractOrError = (regex: RegExp): string => input.slice(pos).match(regex)?.at(0) ?? error('unexpected token.');
    const tokenizeError = (message: string): never => {
      throw new LexicalError(`${message} "${input[pos]}" [${pos}]`, input[pos], pos);
    };
    const error = (message: string): never => {
      throw new SyntaxError(message);
    };
    const prevToken = () => (tokens.length > 0 ? tokens[tokens.length - 1] : null);
    const isUnaryContext = (token: Token | null) => {
      return (
        token === null ||
        token.t === PAREN.left ||
        token.t === OPERATOR.comparison ||
        token.t === OPERATOR.equality ||
        token.t === OPERATOR.logical
      );
    };

    while (pos < input.length) {
      if (input[pos] === ' ') {
        pos++;
        continue;
      }
      if (input[pos] === '"') {
        const value = extractOrError(STRING_LITERAL_REGEX);
        tokens.push({ [PROPERTY_NAME.type]: ATOM.stringLiteral, [PROPERTY_NAME.value]: value });
        pos += value.length;
        continue;
      }
      if (input[pos] === '&' || input[pos] === '|') {
        tokens.push({ [PROPERTY_NAME.type]: OPERATOR.logical, [PROPERTY_NAME.value]: input[pos] });
        pos++;
        continue;
      }
      const bool = extract(BOOL_LITERAL_REGEX);
      if (bool !== null) {
        tokens.push({ [PROPERTY_NAME.type]: ATOM.boolLiteral, [PROPERTY_NAME.value]: bool });
        pos += bool.length;
        continue;
      }
      const num = extract(NUMBER_LITERAL_REGEX);
      if (num !== null) {
        if (input[pos] === '+' || input[pos] === '-') {
          if (isUnaryContext(prevToken())) {
            tokens.push({ [PROPERTY_NAME.type]: ATOM.numberLiteral, [PROPERTY_NAME.value]: num });
            pos += num.length;
            continue;
          }
        } else {
          tokens.push({ [PROPERTY_NAME.type]: ATOM.numberLiteral, [PROPERTY_NAME.value]: num });
          pos += num.length;
          continue;
        }
      }
      if (input[pos] === '+' || input[pos] === '-' || input[pos] === '*' || input[pos] === '/') {
        tokens.push({ [PROPERTY_NAME.type]: OPERATOR.arithmetic, [PROPERTY_NAME.value]: input[pos] });
        pos++;
        continue;
      }
      if (input[pos] === '=' || input[pos] === '!') {
        const value = extractOrError(EQUALITY_OPERATOR_REGEX);
        tokens.push({ [PROPERTY_NAME.type]: OPERATOR.equality, [PROPERTY_NAME.value]: value });
        pos += value.length;
        continue;
      }
      if (input[pos] === '<' || input[pos] === '>') {
        const value = extractOrError(COMPARISON_OPERATOR_REGEX);
        tokens.push({ [PROPERTY_NAME.type]: OPERATOR.comparison, [PROPERTY_NAME.value]: value });
        pos += value.length;
        continue;
      }
      if (input[pos] === '(') {
        tokens.push({ [PROPERTY_NAME.type]: PAREN.left, [PROPERTY_NAME.value]: input[pos] });
        pos++;
        continue;
      }
      if (input[pos] === ')') {
        tokens.push({ [PROPERTY_NAME.type]: PAREN.right, [PROPERTY_NAME.value]: input[pos] });
        pos++;
        continue;
      }
      if (input[pos] === '$') {
        const value = extractOrError(VARIABLE_REGEX);
        tokens.push({ [PROPERTY_NAME.type]: ATOM.variable, [PROPERTY_NAME.value]: value.slice(1, value.length) });
        pos += value.length;
        continue;
      }
      if (input[pos] === '%') {
        const oumv = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.outdoorUnitMasterVrv}${MODEL_PATTERN})`));
        if (oumv) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.outdoorUnitMasterVrv,
            [PROPERTY_NAME.value]: oumv.slice(UNIT_TYPE_PREFIXES.outdoorUnitMasterVrv.length, oumv.length),
          });
          pos += oumv.length;
          continue;
        }
        const ous1v = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.outdoorUnitSlave1Vrv}${MODEL_PATTERN})`));
        if (ous1v) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.outdoorUnitSlave1Vrv,
            [PROPERTY_NAME.value]: ous1v.slice(UNIT_TYPE_PREFIXES.outdoorUnitSlave1Vrv.length, ous1v.length),
          });
          pos += ous1v.length;
          continue;
        }
        const ous2v = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.outdoorUnitSlave2Vrv}${MODEL_PATTERN})`));
        if (ous2v) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.outdoorUnitSlave2Vrv,
            [PROPERTY_NAME.value]: ous2v.slice(UNIT_TYPE_PREFIXES.outdoorUnitSlave2Vrv.length, ous2v.length),
          });
          pos += ous2v.length;
          continue;
        }
        const ou = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.outdoorUnit}${MODEL_PATTERN})`));
        if (ou) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.outdoorUnit,
            [PROPERTY_NAME.value]: ou.slice(UNIT_TYPE_PREFIXES.outdoorUnit.length, ou.length),
          });
          pos += ou.length;
          continue;
        }
        const t = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.waterTank}${MODEL_PATTERN})`));
        if (t) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.waterTank,
            [PROPERTY_NAME.value]: t.slice(UNIT_TYPE_PREFIXES.waterTank.length, t.length),
          });
          pos += t.length;
          continue;
        }
        const boh = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.boosterHeater}${MODEL_PATTERN})`));
        if (boh) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.boosterHeater,
            [PROPERTY_NAME.value]: boh.slice(UNIT_TYPE_PREFIXES.boosterHeater.length, boh.length),
          });
          pos += boh.length;
          continue;
        }
        const bah = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.backupHeater}${MODEL_PATTERN})`));
        if (bah) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.backupHeater,
            [PROPERTY_NAME.value]: bah.slice(UNIT_TYPE_PREFIXES.backupHeater.length, bah.length),
          });
          pos += bah.length;
          continue;
        }
        const rc = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.controller}${MODEL_PATTERN})`));
        if (rc) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.controller,
            [PROPERTY_NAME.value]: rc.slice(UNIT_TYPE_PREFIXES.controller.length, rc.length),
          });
          pos += rc.length;
          continue;
        }
        const fu = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.fanCoilUnit}${MODEL_PATTERN})`));
        if (fu) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.fanCoilUnit,
            [PROPERTY_NAME.value]: fu.slice(UNIT_TYPE_PREFIXES.fanCoilUnit.length, fu.length),
          });
          pos += fu.length;
          continue;
        }
        const r = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.radiator}${MODEL_PATTERN})`));
        if (r) {
          tokens.push({
            [PROPERTY_NAME.type]: ATOM.radiator,
            [PROPERTY_NAME.value]: r.slice(UNIT_TYPE_PREFIXES.radiator.length, r.length),
          });
          pos += r.length;
          continue;
        }
        const b = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.boiler}${MODEL_PATTERN})`));
        if (b) {
          tokens.push({ [PROPERTY_NAME.type]: ATOM.boiler, [PROPERTY_NAME.value]: b.slice(UNIT_TYPE_PREFIXES.boiler.length, b.length) });
          pos += b.length;
          continue;
        }
        const o = extract(new RegExp(`^(${UNIT_TYPE_PREFIXES.other}${MODEL_PATTERN})`));
        if (o) {
          tokens.push({ [PROPERTY_NAME.type]: ATOM.other, [PROPERTY_NAME.value]: o.slice(UNIT_TYPE_PREFIXES.other.length, o.length) });
          pos += o.length;
          continue;
        }
        const indoorUnitKeys = Object.keys(UNIT_TYPE_PREFIXES).filter(key =>
          key.startsWith('indoorUnit'),
        ) as (keyof typeof UNIT_TYPE_PREFIXES)[];
        let isIndoorUnitMatched = false;
        for (const key of indoorUnitKeys) {
          const prefix = UNIT_TYPE_PREFIXES[key];
          const atom = ATOM[key];
          const iu = extract(new RegExp(`^(${prefix}${MODEL_PATTERN})`));
          if (iu) {
            tokens.push({
              [PROPERTY_NAME.type]: atom,
              [PROPERTY_NAME.value]: iu.slice(prefix.length, iu.length),
            });
            pos += iu.length;
            isIndoorUnitMatched = true;
            break;
          }
        }
        if (isIndoorUnitMatched) {
          continue;
        }
      }
      tokenizeError('unexpected token.');
    }

    const operators = tokens.filter(token => isOperatorType(token.t) || isParenType(token.t));
    if (operators.length > MAX_CONDITION_NUM) {
      error(`over the set limit of operators. [operators: ${operators.length}]`);
    }

    return tokens;
  }

  private static parse(tokens: Token[]): AbstractSyntaxTreeNode {
    const queue = [...tokens];

    const peek = (): Token => queue.at(0) ?? { [PROPERTY_NAME.type]: 'end-of-line', [PROPERTY_NAME.value]: '' };

    const poll = (): Token => queue.shift() ?? { [PROPERTY_NAME.type]: 'end-of-line', [PROPERTY_NAME.value]: '' };

    const consume = (expect: TokenType): void => (poll().t === expect ? void 0 : error(`expected token ${expect} is missing.`));

    const error = (message: string): never => {
      throw new SyntaxError(message);
    };

    // <atom> ::= <variable> | <model> | <string-literal> | <number-literal> | <bool-master>
    // <variable> ::= /^\[0-9a-fA-F]{12}7[0-9a-fA-F]{3}[89abAB][0-9a-fA-F]{15}/
    // <model> ::= /^%(?:IU|OU|T|BoH|BaH|RC|FU|R|B|O)_(機種マスタのDB項目名|inst)/
    // <string-literal> ::= /^"[^"] +"/
    // <number-literal> ::= /^(?<!\d)-?\d{1,6}(?:[.,]\d{1,3})?(?!\d)/
    // <bool-literal> ::= /^(True|False)/
    const atom = (): AbstractSyntaxTreeNode => {
      const t = peek().t;
      switch (t) {
        case ATOM.variable:
        case ATOM.outdoorUnitMasterVrv:
        case ATOM.outdoorUnitSlave1Vrv:
        case ATOM.outdoorUnitSlave2Vrv:
        case ATOM.outdoorUnit:
        case ATOM.waterTank:
        case ATOM.boosterHeater:
        case ATOM.backupHeater:
        case ATOM.controller:
        case ATOM.fanCoilUnit:
        case ATOM.radiator:
        case ATOM.boiler:
        case ATOM.other:
        case ATOM.indoorUnit:
        case ATOM.indoorUnit2:
        case ATOM.indoorUnit3:
        case ATOM.indoorUnit4:
        case ATOM.indoorUnit5:
        case ATOM.indoorUnit6:
        case ATOM.indoorUnit7:
        case ATOM.indoorUnit8:
        case ATOM.indoorUnit9:
        case ATOM.indoorUnit10:
        case ATOM.indoorUnit11:
        case ATOM.indoorUnit12:
        case ATOM.indoorUnit13:
        case ATOM.indoorUnit14:
        case ATOM.indoorUnit15:
        case ATOM.indoorUnit16:
        case ATOM.indoorUnit17:
        case ATOM.indoorUnit18:
        case ATOM.indoorUnit19:
        case ATOM.indoorUnit20:
        case ATOM.indoorUnit21:
        case ATOM.indoorUnit22:
        case ATOM.indoorUnit23:
        case ATOM.indoorUnit24:
        case ATOM.indoorUnit25:
        case ATOM.indoorUnit26:
        case ATOM.indoorUnit27:
        case ATOM.indoorUnit28:
        case ATOM.indoorUnit29:
        case ATOM.indoorUnit30:
        case ATOM.indoorUnit31:
        case ATOM.indoorUnit32:
        case ATOM.indoorUnit33:
        case ATOM.indoorUnit34:
        case ATOM.indoorUnit35:
        case ATOM.indoorUnit36:
        case ATOM.indoorUnit37:
        case ATOM.indoorUnit38:
        case ATOM.indoorUnit39:
        case ATOM.indoorUnit40:
        case ATOM.indoorUnit41:
        case ATOM.indoorUnit42:
        case ATOM.indoorUnit43:
        case ATOM.indoorUnit44:
        case ATOM.indoorUnit45:
        case ATOM.indoorUnit46:
        case ATOM.indoorUnit47:
        case ATOM.indoorUnit48:
        case ATOM.indoorUnit49:
        case ATOM.indoorUnit50:
        case ATOM.indoorUnit51:
        case ATOM.indoorUnit52:
        case ATOM.indoorUnit53:
        case ATOM.indoorUnit54:
        case ATOM.indoorUnit55:
        case ATOM.indoorUnit56:
        case ATOM.indoorUnit57:
        case ATOM.indoorUnit58:
        case ATOM.indoorUnit59:
        case ATOM.indoorUnit60:
        case ATOM.indoorUnit61:
        case ATOM.indoorUnit62:
        case ATOM.indoorUnit63:
        case ATOM.indoorUnit64:
        case ATOM.numberLiteral:
        case ATOM.boolLiteral:
          return {
            [PROPERTY_NAME.type]: t,
            [PROPERTY_NAME.value]: poll().v,
          };
        case ATOM.stringLiteral:
          return {
            [PROPERTY_NAME.type]: t,
            [PROPERTY_NAME.value]: poll().v.replace(/"/g, ''),
          };
        default:
          return error(`non-value token can not place there. [type: ${peek().t}, value: ${peek().v}]`);
      }
    };

    // <comparison> ::= <arithmetic> (<comparison-operator> <arithmetic> | <equality-operator> <arithmetic>)
    // <comparison-operator> ::= '<' | '<=' | '>' | '>='
    // <equality-operator> ::= '==' | '!='
    const comparison = (): AbstractSyntaxTreeNode => {
      let node = arithmetic();
      while (peek().t === OPERATOR.comparison || peek().t === OPERATOR.equality) {
        node = {
          [PROPERTY_NAME.type]: peek().t === OPERATOR.comparison ? OPERATOR.comparison : OPERATOR.equality,
          [PROPERTY_NAME.value]: poll().v,
          [PROPERTY_NAME.left]: node,
          [PROPERTY_NAME.right]: arithmetic(),
        };
      }
      return node;
    };

    // <arithmetic> ::= <term> [ ('+' | '-') <term> ]*
    const arithmetic = (): AbstractSyntaxTreeNode => {
      let left = term();
      while (peek().t === OPERATOR.arithmetic && (peek().v === '+' || peek().v === '-')) {
        left = {
          [PROPERTY_NAME.type]: OPERATOR.arithmetic,
          [PROPERTY_NAME.value]: poll().v,
          [PROPERTY_NAME.left]: left,
          [PROPERTY_NAME.right]: term(),
        };
      }
      return left;
    };

    // <term> ::= <factor> [ ('*' | '/') <factor> ]*
    const term = (): AbstractSyntaxTreeNode => {
      let left = factor();
      while (peek().t === OPERATOR.arithmetic && (peek().v === '*' || peek().v === '/')) {
        left = {
          [PROPERTY_NAME.type]: OPERATOR.arithmetic,
          [PROPERTY_NAME.value]: poll().v,
          [PROPERTY_NAME.left]: left,
          [PROPERTY_NAME.right]: factor(),
        };
      }
      return left;
    };

    // <factor> ::= <atom> | <left-paren> <arithmetic> <right-paren>
    const factor = (): AbstractSyntaxTreeNode => {
      switch (peek().t) {
        case PAREN.left:
          return parentheses();
        case ATOM.variable:
        case ATOM.outdoorUnitMasterVrv:
        case ATOM.outdoorUnitSlave1Vrv:
        case ATOM.outdoorUnitSlave2Vrv:
        case ATOM.outdoorUnit:
        case ATOM.waterTank:
        case ATOM.boosterHeater:
        case ATOM.backupHeater:
        case ATOM.controller:
        case ATOM.fanCoilUnit:
        case ATOM.radiator:
        case ATOM.boiler:
        case ATOM.other:
        case ATOM.indoorUnit:
        case ATOM.indoorUnit2:
        case ATOM.indoorUnit3:
        case ATOM.indoorUnit4:
        case ATOM.indoorUnit5:
        case ATOM.indoorUnit6:
        case ATOM.indoorUnit7:
        case ATOM.indoorUnit8:
        case ATOM.indoorUnit9:
        case ATOM.indoorUnit10:
        case ATOM.indoorUnit11:
        case ATOM.indoorUnit12:
        case ATOM.indoorUnit13:
        case ATOM.indoorUnit14:
        case ATOM.indoorUnit15:
        case ATOM.indoorUnit16:
        case ATOM.indoorUnit17:
        case ATOM.indoorUnit18:
        case ATOM.indoorUnit19:
        case ATOM.indoorUnit20:
        case ATOM.indoorUnit21:
        case ATOM.indoorUnit22:
        case ATOM.indoorUnit23:
        case ATOM.indoorUnit24:
        case ATOM.indoorUnit25:
        case ATOM.indoorUnit26:
        case ATOM.indoorUnit27:
        case ATOM.indoorUnit28:
        case ATOM.indoorUnit29:
        case ATOM.indoorUnit30:
        case ATOM.indoorUnit31:
        case ATOM.indoorUnit32:
        case ATOM.indoorUnit33:
        case ATOM.indoorUnit34:
        case ATOM.indoorUnit35:
        case ATOM.indoorUnit36:
        case ATOM.indoorUnit37:
        case ATOM.indoorUnit38:
        case ATOM.indoorUnit39:
        case ATOM.indoorUnit40:
        case ATOM.indoorUnit41:
        case ATOM.indoorUnit42:
        case ATOM.indoorUnit43:
        case ATOM.indoorUnit44:
        case ATOM.indoorUnit45:
        case ATOM.indoorUnit46:
        case ATOM.indoorUnit47:
        case ATOM.indoorUnit48:
        case ATOM.indoorUnit49:
        case ATOM.indoorUnit50:
        case ATOM.indoorUnit51:
        case ATOM.indoorUnit52:
        case ATOM.indoorUnit53:
        case ATOM.indoorUnit54:
        case ATOM.indoorUnit55:
        case ATOM.indoorUnit56:
        case ATOM.indoorUnit57:
        case ATOM.indoorUnit58:
        case ATOM.indoorUnit59:
        case ATOM.indoorUnit60:
        case ATOM.indoorUnit61:
        case ATOM.indoorUnit62:
        case ATOM.indoorUnit63:
        case ATOM.indoorUnit64:
        case ATOM.stringLiteral:
        case ATOM.numberLiteral:
        case ATOM.boolLiteral:
          return atom();
        default:
          return error(`unexpected token in factor. [type: ${peek().t}, value: ${peek().v}]`);
      }
    };

    // <parentheses> ::= <left-paren> <expression> <right-paren> | <comparison>
    // <left-paren> ::= '('
    // <right-paren> ::= ')'
    const parentheses = (): AbstractSyntaxTreeNode => {
      if (peek().t === PAREN.left) {
        consume(PAREN.left);
        const node = expression();
        consume(PAREN.right);
        return node;
      }
      return arithmetic();
    };

    // <conjunction> ::= <parentheses> [ <logical-operator-and> <parentheses> ]*
    // <logical-operator-and> ::= '&'
    const conjunction = (): AbstractSyntaxTreeNode => {
      let node = comparison();
      while (peek().t === OPERATOR.logical && peek().v === '&') {
        node = {
          [PROPERTY_NAME.type]: OPERATOR.logical,
          [PROPERTY_NAME.value]: poll().v,
          [PROPERTY_NAME.left]: node,
          [PROPERTY_NAME.right]: comparison(),
        };
      }
      return node;
    };

    // <disjunction> ::= <conjunction> [ <logical-operator-or> <conjunction> ]*
    // <logical-operator-or> ::= '|'
    const disjunction = (): AbstractSyntaxTreeNode => {
      let node = conjunction();
      while (peek().t === OPERATOR.logical && peek().v === '|') {
        node = {
          [PROPERTY_NAME.type]: OPERATOR.logical,
          [PROPERTY_NAME.value]: poll().v,
          [PROPERTY_NAME.left]: node,
          [PROPERTY_NAME.right]: conjunction(),
        };
      }
      return node;
    };

    // <expression> ::= <disjunction>
    const expression = (): AbstractSyntaxTreeNode => disjunction();

    const ast = expression();
    if (queue.length) {
      error('unconsumed token(s).');
    }
    return ast;
  }

  private static analyze(ast: AbstractSyntaxTreeNode, resultTypeMap: Map<string, string>): void {
    const isExit = (node: AtomNode): void => {
      const resultType = resultTypeMap.get(node.v);
      if (!resultType) {
        return error('the reference does not exist', node);
      }
    };
    const error = (message: string, node: AbstractSyntaxTreeNode): never => {
      throw new SemanticError(message, node);
    };

    const containsVariable = (node: AbstractSyntaxTreeNode): boolean => {
      switch (node.t) {
        case OPERATOR.logical:
          return containsVariable(node.l) && containsVariable(node.r);
        case OPERATOR.arithmetic:
        case OPERATOR.equality:
        case OPERATOR.comparison:
          if (containsVariable(node.l)) {
            return true;
          }
          if (containsVariable(node.r)) {
            return true;
          }
          return false;
        case ATOM.variable:
        case ATOM.outdoorUnitMasterVrv:
        case ATOM.outdoorUnitSlave1Vrv:
        case ATOM.outdoorUnitSlave2Vrv:
        case ATOM.outdoorUnit:
        case ATOM.waterTank:
        case ATOM.boosterHeater:
        case ATOM.backupHeater:
        case ATOM.controller:
        case ATOM.fanCoilUnit:
        case ATOM.radiator:
        case ATOM.boiler:
        case ATOM.other:
        case ATOM.indoorUnit:
        case ATOM.indoorUnit2:
        case ATOM.indoorUnit3:
        case ATOM.indoorUnit4:
        case ATOM.indoorUnit5:
        case ATOM.indoorUnit6:
        case ATOM.indoorUnit7:
        case ATOM.indoorUnit8:
        case ATOM.indoorUnit9:
        case ATOM.indoorUnit10:
        case ATOM.indoorUnit11:
        case ATOM.indoorUnit12:
        case ATOM.indoorUnit13:
        case ATOM.indoorUnit14:
        case ATOM.indoorUnit15:
        case ATOM.indoorUnit16:
        case ATOM.indoorUnit17:
        case ATOM.indoorUnit18:
        case ATOM.indoorUnit19:
        case ATOM.indoorUnit20:
        case ATOM.indoorUnit21:
        case ATOM.indoorUnit22:
        case ATOM.indoorUnit23:
        case ATOM.indoorUnit24:
        case ATOM.indoorUnit25:
        case ATOM.indoorUnit26:
        case ATOM.indoorUnit27:
        case ATOM.indoorUnit28:
        case ATOM.indoorUnit29:
        case ATOM.indoorUnit30:
        case ATOM.indoorUnit31:
        case ATOM.indoorUnit32:
        case ATOM.indoorUnit33:
        case ATOM.indoorUnit34:
        case ATOM.indoorUnit35:
        case ATOM.indoorUnit36:
        case ATOM.indoorUnit37:
        case ATOM.indoorUnit38:
        case ATOM.indoorUnit39:
        case ATOM.indoorUnit40:
        case ATOM.indoorUnit41:
        case ATOM.indoorUnit42:
        case ATOM.indoorUnit43:
        case ATOM.indoorUnit44:
        case ATOM.indoorUnit45:
        case ATOM.indoorUnit46:
        case ATOM.indoorUnit47:
        case ATOM.indoorUnit48:
        case ATOM.indoorUnit49:
        case ATOM.indoorUnit50:
        case ATOM.indoorUnit51:
        case ATOM.indoorUnit52:
        case ATOM.indoorUnit53:
        case ATOM.indoorUnit54:
        case ATOM.indoorUnit55:
        case ATOM.indoorUnit56:
        case ATOM.indoorUnit57:
        case ATOM.indoorUnit58:
        case ATOM.indoorUnit59:
        case ATOM.indoorUnit60:
        case ATOM.indoorUnit61:
        case ATOM.indoorUnit62:
        case ATOM.indoorUnit63:
        case ATOM.indoorUnit64:
          return true;
        case ATOM.numberLiteral:
        case ATOM.stringLiteral:
        default:
          return false;
      }
    };

    const containsOperator = (node: AbstractSyntaxTreeNode): boolean => {
      switch (node.t) {
        case OPERATOR.logical:
          return containsOperator(node.l) && containsOperator(node.r);
        case OPERATOR.equality:
        case OPERATOR.comparison:
          return true;
        default:
          return false;
      }
    };

    const noOperatorError = (node: AbstractSyntaxTreeNode): void => {
      if (!containsOperator(node)) {
        return error('operator must be specified.', ast);
      }
    };

    const neeedsErrorBothSides = (node: AbstractSyntaxTreeNode): void => {
      if (!containsVariable(node)) {
        return error('same literal type cannot be specified.', ast);
      }
    };

    const atom = (node: AbstractSyntaxTreeNode): TokenType | 'boolean' => {
      switch (node.t) {
        case ATOM.numberLiteral:
          return ATOM.numberLiteral;
        case ATOM.stringLiteral:
          return ATOM.stringLiteral;
        case ATOM.boolLiteral:
          return ATOM.boolLiteral;
        case ATOM.variable: {
          isExit(node);
          const resultType = resultTypeMap.get(node.v);
          if (resultType === 'yesno' || resultType === 'select') {
            return ATOM.stringLiteral;
          } else {
            return ATOM.numberLiteral;
          }
        }
        case ATOM.outdoorUnitMasterVrv:
        case ATOM.outdoorUnitSlave1Vrv:
        case ATOM.outdoorUnitSlave2Vrv:
        case ATOM.outdoorUnit:
        case ATOM.waterTank:
        case ATOM.boosterHeater:
        case ATOM.backupHeater:
        case ATOM.controller:
        case ATOM.fanCoilUnit:
        case ATOM.radiator:
        case ATOM.boiler:
        case ATOM.other:
        case ATOM.indoorUnit:
        case ATOM.indoorUnit2:
        case ATOM.indoorUnit3:
        case ATOM.indoorUnit4:
        case ATOM.indoorUnit5:
        case ATOM.indoorUnit6:
        case ATOM.indoorUnit7:
        case ATOM.indoorUnit8:
        case ATOM.indoorUnit9:
        case ATOM.indoorUnit10:
        case ATOM.indoorUnit11:
        case ATOM.indoorUnit12:
        case ATOM.indoorUnit13:
        case ATOM.indoorUnit14:
        case ATOM.indoorUnit15:
        case ATOM.indoorUnit16:
        case ATOM.indoorUnit17:
        case ATOM.indoorUnit18:
        case ATOM.indoorUnit19:
        case ATOM.indoorUnit20:
        case ATOM.indoorUnit21:
        case ATOM.indoorUnit22:
        case ATOM.indoorUnit23:
        case ATOM.indoorUnit24:
        case ATOM.indoorUnit25:
        case ATOM.indoorUnit26:
        case ATOM.indoorUnit27:
        case ATOM.indoorUnit28:
        case ATOM.indoorUnit29:
        case ATOM.indoorUnit30:
        case ATOM.indoorUnit31:
        case ATOM.indoorUnit32:
        case ATOM.indoorUnit33:
        case ATOM.indoorUnit34:
        case ATOM.indoorUnit35:
        case ATOM.indoorUnit36:
        case ATOM.indoorUnit37:
        case ATOM.indoorUnit38:
        case ATOM.indoorUnit39:
        case ATOM.indoorUnit40:
        case ATOM.indoorUnit41:
        case ATOM.indoorUnit42:
        case ATOM.indoorUnit43:
        case ATOM.indoorUnit44:
        case ATOM.indoorUnit45:
        case ATOM.indoorUnit46:
        case ATOM.indoorUnit47:
        case ATOM.indoorUnit48:
        case ATOM.indoorUnit49:
        case ATOM.indoorUnit50:
        case ATOM.indoorUnit51:
        case ATOM.indoorUnit52:
        case ATOM.indoorUnit53:
        case ATOM.indoorUnit54:
        case ATOM.indoorUnit55:
        case ATOM.indoorUnit56:
        case ATOM.indoorUnit57:
        case ATOM.indoorUnit58:
        case ATOM.indoorUnit59:
        case ATOM.indoorUnit60:
        case ATOM.indoorUnit61:
        case ATOM.indoorUnit62:
        case ATOM.indoorUnit63:
        case ATOM.indoorUnit64: {
          if (node.v === INSTALLATION_KEY) {
            return ATOM.boolLiteral;
          }
          switch (CSV_FORMAT.find(format => format.name === node.v)?.type) {
            case 'string':
              return ATOM.stringLiteral;
            case 'bool':
              return ATOM.boolLiteral;
            case 'number':
              return ATOM.numberLiteral;
            default:
              return error('invalid model', node);
          }
        }
        default:
          return expression(node);
      }
    };

    const arithmetic = (node: OperatorNode): TokenType => {
      const left = node.l ? atom(node.l) : null;
      const right = node.r ? atom(node.r) : null;
      if (left === ATOM.numberLiteral && right === ATOM.numberLiteral) {
        return ATOM.numberLiteral;
      }
      return error(`non-number literals cannot be calculated. ${left} and ${right}`, node);
    };

    const comparison = (node: OperatorNode): TokenType | 'boolean' => {
      const left = node.l ? atom(node.l) : null;
      const right = node.r ? atom(node.r) : null;
      if (left === ATOM.numberLiteral && right === ATOM.numberLiteral) {
        return 'boolean';
      }
      return error(`non-number literals cannot be compared. ${left} and ${right}`, node);
    };

    const equality = (node: OperatorNode): TokenType | 'boolean' => {
      const left = node.l ? atom(node.l) : null;
      const right = node.r ? atom(node.r) : null;
      if (left === right) {
        return 'boolean';
      }
      return error(`different types cannot be compared. ${left} and ${right}`, node);
    };

    const logical = (node: OperatorNode): TokenType | 'boolean' => {
      const left = node.l ? atom(node.l) : null;
      const right = node.r ? atom(node.r) : null;
      if (left === 'boolean' && right === 'boolean') {
        return 'boolean';
      }
      return error(`invalid operands for logical. ${left} and ${right}`, node);
    };

    const expression = (node: AbstractSyntaxTreeNode): TokenType | 'boolean' => {
      switch (node.t) {
        case OPERATOR.arithmetic:
          return arithmetic(node);
        case OPERATOR.comparison:
          return comparison(node);
        case OPERATOR.equality:
          return equality(node);
        case OPERATOR.logical:
          return logical(node);
        default:
          return error(`atom elements must be operated on.`, node);
      }
    };

    noOperatorError(ast);
    neeedsErrorBothSides(ast);
    expression(ast);
  }
}
